import React from 'react'
import { ResearcherType } from './researcher'
import useManageProjectStore from '../../../../../../stores/manageProject/useManageProjectStore'

import useCheckPermission from '../../../../../../utilities/checkPermission'
import * as ResearcherOtherType from './researcherOtherType'
import constSubmittedType from '../../../../../../constants/submittedType'
import useIRB from '../../../../../../services/um/lookups/useIRB'

export default (props: ResearcherType) => {
    const { projectMode } = props
    const manageProjectStore = useManageProjectStore()
    const checkPermission = useCheckPermission()
    const { irb } = useIRB()

    const formValueRef = React.useRef<any>()

    const [initialData, setInitialData] = React.useState<any>()

    const isViewMode = checkPermission.chkProjectStepViewMode(
        manageProjectStore.projectData ? manageProjectStore.projectData : undefined,
    )

    React.useEffect(() => {
        const mode = projectMode
        if (mode === 'CREATE') {
            createInitialFormData()
        } else if (mode === 'EDIT') {
            editInitialFormData()
        }
    }, [manageProjectStore.projectData?.submittedID ?? null, irb ?? null])

    const createInitialFormData = () => {
        let initialData: ResearcherOtherType.InitialFormValueType = {
            isPhase: '1',
            langTH: true,
            isCertificatePaperList: '1',
            academicPosition: `7`, //ไม่ระบุ
        }
        setInitialData(initialData)
    }

    const editInitialFormData = () => {
        let isRequestCertificatePager: string | null = null
        if (typeof manageProjectStore.projectData?.isRequestCertificatePager === 'boolean') {
            if (manageProjectStore.projectData?.isRequestCertificatePager === true) {
                isRequestCertificatePager = '1'
            } else {
                isRequestCertificatePager = '2'
            }
        }
        let initialData: ResearcherOtherType.InitialFormValueType = {
            academicPositionID: manageProjectStore.projectData?.academicPositionInfo?.value,
            // otherAcademicPosition: manageProjectStore.projectData?.academicPositionOther,
            otherAcademicPositionTH: manageProjectStore.projectData?.academicPositionOther_th,
            otherAcademicPositionEN: manageProjectStore.projectData?.academicPositionOther_en,
            email: manageProjectStore.projectData?.email,
            faculty: {
                label: `${manageProjectStore.projectData?.facultyInfo?.nameTH}`,
                value: `${manageProjectStore.projectData?.facultyInfo?.value}`,
            },
            fax: manageProjectStore.projectData?.fax,
            homePhone: manageProjectStore.projectData?.homePhone,
            irb: manageProjectStore.projectData?.irb,
            isDraft: manageProjectStore.projectData?.isDraft,
            mobilePhone: manageProjectStore.projectData?.mobilePhone,
            projectNameEN: manageProjectStore.projectData?.projectName_en,
            projectNameTH: manageProjectStore.projectData?.projectName_th,
            projectSubmitType: {
                label: `${manageProjectStore.projectData?.submitTypeInfo?.nameTH}`,
                value: `${manageProjectStore.projectData?.submitTypeInfo?.value}`,
            },
            nameEN: manageProjectStore.projectData?.researcherName_en,
            nameTH: manageProjectStore.projectData?.researcherName_th,
            //@ts-ignore
            researcherType:
                manageProjectStore.projectData?.researcherTypeInfo &&
                manageProjectStore.projectData?.researcherTypeInfo.value
                    ? {
                          label: `${manageProjectStore.projectData?.researcherTypeInfo?.nameTH}`,
                          value: `${manageProjectStore.projectData?.researcherTypeInfo?.value}`,
                      }
                    : null,
            educationLevel:
                manageProjectStore.projectData?.educationLevelInfo &&
                manageProjectStore.projectData?.educationLevelInfo.value
                    ? {
                          label: `${manageProjectStore.projectData?.educationLevelInfo?.nameTH}`,
                          value: `${manageProjectStore.projectData?.educationLevelInfo?.value}`,
                      }
                    : null,
            titleNameID: manageProjectStore.projectData?.titleNameInfo?.value,
            // otherTitleName: manageProjectStore.projectData?.titleNameOther,
            otherTitleNameTH: manageProjectStore.projectData?.titleNameOther_th,
            otherTitleNameEN: manageProjectStore.projectData?.titleNameOther_en,
            isPhase: manageProjectStore.projectData?.requestPhase ? '2' : '1', //`${manageProjectStore.projectData?.submitTypeInfo.value}`, //'2', // hardcode
            isTools: manageProjectStore.projectData?.isTools ? '2' : '1',
            IRB: irb.filter((itm) => parseInt(itm.value) === manageProjectStore.projectData?.irb)[0] || null,
            titleName: `${manageProjectStore.projectData?.titleNameInfo?.value}` || null,
            academicPosition: `${manageProjectStore.projectData?.academicPositionInfo?.value}` || null,
            langTH: manageProjectStore.projectData?.isLanguageTH ? manageProjectStore.projectData?.isLanguageTH : false,
            langEN: manageProjectStore.projectData?.isLanguageEN ? manageProjectStore.projectData?.isLanguageEN : false,
            isCertificatePaperList: isRequestCertificatePager,
            remarkFromAdmin: manageProjectStore.projectData?.verifyDocumentRemark || null,
            numPhase: manageProjectStore.projectData?.requestPhase,
            isDr: manageProjectStore.projectData?.isDr ? manageProjectStore.projectData?.isDr : false,
            researchProjectSummaryTH: manageProjectStore.projectData?.researchProjectSummary_th ?? null,
            researchProjectSummaryEN: manageProjectStore.projectData?.researchProjectSummary_en ?? null,
            projectAdvisor: manageProjectStore.projectData?.projectAdvisor ?? null,
            projectAdvisorEmail: manageProjectStore.projectData?.projectAdvisorEmail ?? null,
            projectAdvisorEmailReserve: manageProjectStore.projectData?.projectAdvisorEmailReserve ?? null,
            coResearcher: manageProjectStore.projectData?.coResearcher
                ? manageProjectStore.projectData?.coResearcher?.map((e) => {
                      return {
                          ...e,
                          titleName: e.titleNameId ? e.titleNameId.toString() : null,
                          academicPosition: e.academicPositionId ? e.academicPositionId.toString() : null,
                          otherTitleNameTH: e.otherTitleNameTh ?? null,
                          otherTitleNameEN: e.otherTitleNameEn ?? null,
                          otherAcademicPositionTH: e.otherAcademicPositionTh ?? null,
                          otherAcademicPositionEN: e.otherAcademicPositionEn ?? null,
                          isDr: e.isAcademicPhd ?? null,
                          nameEN: e.nameEn ?? null,
                          nameTH: e.nameTh ?? null,
                          homePhone: e.homePhoneNumber ?? null,
                          mobilePhone: e.phoneNumber ?? null,
                      }
                  })
                : [],
        }

        setInitialData(initialData)
    }

    return {
        formValueRef,
        isViewMode,
        projectData: manageProjectStore.projectData,
        initialData: initialData,
        submittedType:
            manageProjectStore.projectData?.submitTypeInfo?.value ?? constSubmittedType.firstSubmitConsideration,
    }
}
